import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './assets/styles/style.css'
import 'primeicons/primeicons.css'

import I18NextVue from 'i18next-vue'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import { primeConfig } from '@/prime-config.ts'
import ToastService from 'primevue/toastservice'
import { initSentry } from '@/plugins/sentry.ts'
import { initMatomo } from '@/plugins/matomo.ts'
import { setupAppHead } from '@/utils/appHead.ts'
import { printBanner } from '@/utils/printBanner.ts'
import { initTranslations } from '@/utils/strapiTranslations.ts'
import { useAuthStore } from '@/stores/auth.store.ts'
import App from './App.vue'
import router from './router/router.ts'

export const app = createApp(App)
export const pinia = createPinia()
const head = setupAppHead(router)

printBanner()

app.use(PrimeVue, primeConfig)

const i18next = await initTranslations(app.config.globalProperties.$primevue.config)
app.use(I18NextVue, { i18next })

app.use(ToastService)
app.directive('tooltip', Tooltip)
app.use(ConfirmationService)
app.use(pinia)

await useAuthStore().init()

app.use(router)
app.use(head)

initMatomo(app, router)
initSentry(app, router)

app.mount('#app')
